import React from 'react'

export default function Footer() {
    return (
        <div className="moviefooter">
            <div className="footerIconlist">
                <div className="iconEffect"><i class="fab fa-facebook-f"></i>
 </div>
                <div className="iconEffect">            <i class="fab fa-instagram"></i>
 </div>
                <div className="iconEffect">            <i class="fab fa-twitter"></i>
 </div>
                <div className="iconEffect">            <i class="fab fa-youtube"></i>
 </div>
                <div className="iconEffect">            <i class="fab fa-twitch"></i>
 </div>

            </div>

<div  className="moviefooter2 row">
<div className="externalLink">Press Room</div>
<div className="externalLink">Advertising<i style={{paddingLeft:"7px"}} class="fas fa-external-link-alt"></i></div>
<div className="externalLink">Jobs<i  style={{paddingLeft:"7px"}}class="fas fa-external-link-alt"></i>    </div>

<div className="externalLink">Conditions of Use</div>
<div className="externalLink"> Privacy Policy
   </div>
<div className="externalLink"> Interest-Based Ads<i style={{paddingLeft:"7px"}} class="fas fa-external-link-alt"></i>
   </div>

 







</div>


<div className="moviefooter3 row">
<div className="externalLink">     Get the IMDb App<i style={{paddingLeft:"7px"}} class="fas fa-external-link-alt"></i>
   </div>
<div className="externalLink"> Help<i style={{paddingLeft:"7px"}} class="fas fa-external-link-alt"></i>
   </div>
<div className="externalLink"> Site Index<i style={{paddingLeft:"7px"}}class="fas fa-external-link-alt"></i>
   </div>
<div className="externalLink"> IMDbPro<i style={{paddingLeft:"7px"}}class="fas fa-external-link-alt"></i>
   </div>
<div className="externalLink"> Box Office Mojo<i style={{paddingLeft:"7px"}} class="fas fa-external-link-alt"></i>
   </div>
<div className="externalLink">  IMDb Developer<i style={{paddingLeft:"7px"}} class="fas fa-external-link-alt"></i></div>
  </div>





<div className="moviefooter4"> This is    <span className="cineplexfootertitle">Cin(e)Plex </span>       </div>


            <div  className="moviefooter5">
            © 2019-2020 by Nhan Nguyen.
            </div>
        </div>
    )
}
